<div *ngIf="loading" class="loading-text">
    <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
    <app-sub-header [pageTitle]="'ServiceOdometerInput' | translate"></app-sub-header>

    <div class="padded-container">
        <div *ngIf="odometerResponse?.odometerValue">
            <dx-form [formData]="odometerResponse" [colCount]="1">
                <dxi-item itemType="group" caption="{{ 'OdometerStartValue' | translate }}">
                    <dxi-item>
                        <dx-number-box [(value)]="startOdometerValue" [showSpinButtons]="true" [min]="odometerResponse?.odometerValue?.odometerEndVal"></dx-number-box>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="{{ 'StartTime' | translate }}">
                    <div class="row">
                        <div class="col-6">
                            <dx-select-box [(value)]="startHours" [dataSource]="hours" displayExpr="value" valueExpr="value"></dx-select-box>
                        </div>
                        <div class="col-6">
                            <dx-select-box [(value)]="startMinutes" [dataSource]="minutes" displayExpr="value" valueExpr="value"></dx-select-box>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item itemType="group" caption="{{ 'Date' | translate }}">
                    <dx-date-box [(value)]="chosenDate" displayFormat="dd/MM/yyyy"></dx-date-box>
                </dxi-item>
                <dxi-item>
                    <div class="button-container">
                        <dx-button class="half-width-button" type="default"
                            [text]="isMobile ? '<' : ('PreviousDay' | translate)" 
                            (onClick)="dayBack()">
                        </dx-button>
                        <dx-button class="half-width-button" type="default" 
                            [text]="isMobile ? '>' : ('NextDay' | translate)" 
                            (onClick)="dayForward()">
                        </dx-button>
                    </div>
                </dxi-item>
            </dx-form>
            <dx-button class="full-width-button" text="{{ 'Save' | translate }}" type="default" (onClick)="startVoucher()" [disabled]="isButtonDisabled"></dx-button>
            <dx-button class="full-width-button" text="{{ 'Back' | translate }}" type="default" (onClick)="goBack()"></dx-button>
        </div>
        <div *ngIf="!odometerResponse?.odometerValue">
            <span>{{ 'Loading data, please wait...' | translate }}</span>
        </div>
    </div>
</div>